import { BXLoader } from '../BXLoader';

const Loader = {
	name: 'Loader',
	functional: true,
	props: {
		loading: Boolean,
	},
	render(h, { props, slots, data: { ref, ...data }}) {
		return (
			<div class="relative" { ...data }>
				{ props.loading ? (
					<BXLoader
						ref={ ref }
						style={{
							'background-color': '#fffa',
							'z-index': 10,
						}}
					/>
				) : null}
				{ slots().default }
			</div>
		)
	}
}

export default Loader
